export const namespace = 'FANSALON'
